import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/LanguageContext';
import fotoVinha2 from '../assets/foto_vinha2.jpg';

/**
 * Página de território (Douro Superior, Vale da Vilariça, Origem).
 *
 * Props:
 *   keyBase {string}  — prefixo das chaves de tradução
 *                       (ex: "territorio.douroSup")
 *   bg      {string}  — opcional, imagem de fundo do header
 */
export default function Territorio({ keyBase, bg = fotoVinha2 }) {
  const t = useT();
  const longText = t(`${keyBase}.long`);
  const paragraphs = longText.split('\n\n').filter(Boolean);

  return (
    <div className="page-top">

      {/* ── Header ── */}
      <section
        className="section"
        style={{
          background: `linear-gradient(160deg, rgba(14,7,4,0.65) 0%, rgba(14,7,4,0.35) 100%), url(${bg}) center/cover no-repeat`,
          paddingTop: 'calc(var(--nav-height) + var(--sp-16))',
        }}
      >
        <div className="container">
          <div style={{ maxWidth: '720px' }}>
            <p className="t-label" style={{ color: '#ffffff', marginBottom: 'var(--sp-4)' }}>
              {t(`${keyBase}.eyebrow`)}
            </p>
            <h1 className="t-h1 t-white" style={{ marginBottom: 'var(--sp-6)', textTransform: 'uppercase' }}>
              {t(`${keyBase}.title`)}
            </h1>
          </div>
        </div>
      </section>

      {/* ── Texto longo ── */}
      <section className="section">
        <div className="container--narrow">
          {paragraphs.map((p, i) => (
            <p
              key={i}
              className="t-body-lg t-light"
              style={{ marginBottom: 'var(--sp-6)', lineHeight: 1.7 }}
            >
              {p}
            </p>
          ))}

          <div style={{ marginTop: 'var(--sp-12)' }}>
            <Link to="/" className="btn">← {t('cart.continueShopping').replace('← ', '').replace('Continuar a comprar', 'Voltar ao início')}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
